import { Routes, Route } from "react-router-dom";

import {
  Home,
  Explore,
  Saved,
  CreatePost,
  Profile,
  EditPost,
  PostDetails,
  UpdateProfile,
  ChatContainer,
  Bizz,
  
} from "@/_root/pages";
import AuthLayout from "./_auth/AuthLayout";
import RootLayout from "./_root/RootLayout";
import SignupForm from "@/_auth/forms/SignupForm";
import SigninForm from "@/_auth/forms/SigninForm";
import { Toaster } from "@/components/ui/toaster";

import "./globals.css";
import ForgotPassword from "./_auth/forms/ForgotPassword";
import ResetPassword from "./_auth/forms/ResetPassword";
import VerifyPhone from "./_auth/forms/VerifyPhone";
import { AuthCallback } from "./_auth/forms/AuthCallback";
import PrivacyPolicy from "./_auth/forms/PrivacyPolicy";
import Admin from "./_root/pages/AdminPage";
import { useUserContext } from "./context/AuthContext";
import { HelmetProvider } from 'react-helmet-async';
import Transactions from "./_root/pages/Transactions";
import { useEffect } from "react";
import { notificationService } from "./services/NotificationService";
import { useGetCurrentUser } from "./lib/react-query/queries";
import { TermsAndConditions } from "./_auth/forms/TermsAndConditions";
import LivePage from "./_root/pages/live";
import CreateStreamPage from "./_root/pages/live/create";
import StreamViewPage from "./_root/pages/live/[id]";
import Sellers from "./_root/pages/Sellers";
import FAQ from "./_auth/forms/FAQ";
import TrustScoreDashboard from "./components/shared/TrustScoreDashboard";
import UserGuide from "./_auth/forms/UserGuide";

const App = () => {
  const { isAuthenticated } = useUserContext();
  const { data: currentUser } = useGetCurrentUser();
  useEffect(() => {
    // Mobile sound pre-load
    const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
    const handleInteraction = () => {
      new Audio("/assets/sounds/notification.mp3").load();
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
    };

    if (isMobile) {
      window.addEventListener("click", handleInteraction, { once: true });
      window.addEventListener("touchstart", handleInteraction, { once: true });
    }

    // Notification listener
    if (currentUser?.$id) {
      const unsubscribe = notificationService.listenForUserNotifications(currentUser.$id);
      return () => unsubscribe();
    }
  }, [currentUser?.$id]);
  
  return (
    <HelmetProvider>
      <main className="flex min-h-[100dvh] flex-col">
        <Routes>
          {/* public routes */}
          <Route element={<AuthLayout />}>
            <Route path="/sign-in" element={<SigninForm />} />
            <Route path="/sign-up" element={<SignupForm />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-phone" element={<VerifyPhone />} />
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="*" element={isAuthenticated? <Home />:<SigninForm />} />
            <Route path="/busiconn-user-guide" element={<UserGuide />} />
          </Route>

          {/* private routes */}
          <Route element={<RootLayout />}>
            <Route index element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/saved" element={<Saved />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/chats" element={<ChatContainer />} />
            <Route path="/chats/:id" element={<ChatContainer />} />
            <Route path="/create-post" element={<CreatePost />} />
            <Route path="/update-post/:id" element={<EditPost />} />
            <Route path="/posts/:id" element={<PostDetails />} />
            <Route path="/profile/:id/*" element={<Profile />} />
            <Route path="/update-profile/:id" element={<UpdateProfile />} />
            <Route path="/admin-moderation" element={<Admin />} />
            <Route path="/sellers" element={<Sellers />} />
            <Route path="/bizz" element={<Bizz />} />
            <Route path="/live" element={<LivePage />} />
            <Route path="/live/create" element={<CreateStreamPage />} />
            <Route path="/live/:id" element={<StreamViewPage />} />
            <Route path="/privacy-policies" element={<PrivacyPolicy />} />
            <Route path="/termandcondition" element={<TermsAndConditions />} />
            <Route path="/trust-score" element={<TrustScoreDashboard />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/busiconn-guide" element={<UserGuide />} />
          </Route>
        </Routes>

        <Toaster />
      </main>
    </HelmetProvider>
  );
};

export default App;
